import { css } from 'styled-components';

interface Breakpoints {
  xs: number;
  sm: number;
  md: number;
  lg: number;
  xl: number;

  [key: string]: number;
}

enum Breakpoint {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl'
}

// https://material-ui.com/layout/breakpoints
export const breakpoints: Breakpoints = {
  xs: 360,
  sm: 600,
  md: 905,
  lg: 1240,
  xl: 1440
};

// Iterate through the sizes and create a media template
export const screenSizeQueryMax: { [prop in keyof typeof breakpoints]: (v1: any, v2?: any) => string } = Object.keys(
  breakpoints
).reduce((acc: any, curr) => {
  const minWidthSize = curr === Breakpoint.xs ? 0 : breakpoints[curr];
  acc[curr] = (v1: any, v2: any) => css`
    @media (max-width: ${minWidthSize}px) {
      ${css(v1, v2)};
    }
  `;
  return acc;
}, {});
